var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading-modal",attrs:{"id":"loadingModal"}},[_c('div',{staticClass:"loading-spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }